import { apiClient } from './api';
import type {
  WorkoutAdaptationContext,
  WorkoutAdaptationResponse,
  WorkoutCheckInPayload,
} from './types';

export class WorkoutAdaptationService {
  static async getContext(sessionId: number, gymId?: number | null): Promise<WorkoutAdaptationContext> {
    const query = gymId ? `?gymId=${gymId}` : '';
    const response = await apiClient.get<WorkoutAdaptationContext>(
      `/api/workout-adaptation/${sessionId}/context${query}`
    );

    return response.data;
  }

  static async submitCheckIn(
    sessionId: number,
    payload: WorkoutCheckInPayload,
    forceTimeout = false,
  ): Promise<WorkoutAdaptationResponse> {
    const response = await apiClient.post<WorkoutAdaptationResponse>(
      `/api/workout-adaptation/${sessionId}/check-in`,
      payload,
      {
        headers: forceTimeout ? { 'X-Force-AI-Timeout': '1' } : undefined,
      }
    );

    return response.data;
  }
}

export default WorkoutAdaptationService;
